import * as globalConfiguration from "@web/global-config.json";

export declare type GlobalConfiguration = typeof import("./global-config.json");
export const getGlobalConfiguration = () => <GlobalConfiguration>(globalConfiguration as any).default; // helper method to access configuration file
